import { createContext, useContext, useState } from "react";
import { DICTS } from "./dictionaries";

const LanguageContext = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

function resolve(dict, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
}

function interpolate(value, vars) {
  if (typeof value === "string") {
    return value.replace(/\{(\w+)\}/g, (_, k) => (vars && vars[k] !== undefined ? vars[k] : `{${k}}`));
  }
  if (Array.isArray(value)) return value.map((v) => interpolate(v, vars));
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, interpolate(v, vars)]));
  }
  return value;
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("edunexa-lang") || "es");

  const setLang = (code) => {
    setLangState(code);
    localStorage.setItem("edunexa-lang", code);
  };

  const t = (path, vars) => {
    let value = resolve(DICTS[lang], path);
    if (value === undefined && lang !== "es") value = resolve(DICTS.es, path);
    if (value === undefined) return path;
    return interpolate(value, vars);
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
